[
  {
    "revision": "43a007d3",
    "url": "/dashboard"
  },
  {
    "revision": "icon-v1",
    "url": "/favicon.ico"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/favicon-16x16.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/favicon-32x32.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/favicon-48x48.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/apple-touch-icon.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/android-chrome-192x192.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/android-chrome-512x512.png"
  },
  {
    "revision": "icon-v1",
    "url": "/icon/maskable/maskable_icon_x512.png"
  },
  {
    "revision": "43a007d3",
    "url": "/manifest.webmanifest"
  }
]